<mat-tab-group>
    <mat-tab label="Memos" *ngIf="hasMemos">
        <mat-accordion>
            <mat-expansion-panel *ngFor="let inventory of inventoryMemos | keyvalue">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{inventory.key}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <table mat-table class="rep-inventory" [dataSource]="inventory.value">
                    <ng-container matColumnDef="InventoryID">
                        <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                        <td mat-cell *matCellDef="let inv">
                            <svg class="lifecycle" [ngClass]="inv.LifeCycle">
                                <circle class="cls-3" cx="0.5em" cy="0.5em" r="0.5em">
                                </circle>
                            </svg>
                            {{inv.InventoryID}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Description">
                        <th mat-header-cell *matHeaderCellDef>Description</th>
                        <td mat-cell *matCellDef="let inv">{{inv.Description}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Qty">
                        <th mat-header-cell *matHeaderCellDef>Qty</th>
                        <td mat-cell *matCellDef="let inv">{{inv.QtyAvailable}} {{inv.BaseUnit}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let inventoryCards; columns: tableColumnsToDisplay"></tr>
                </table>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-tab>
    <mat-tab label="Cards" *ngIf="inventoryCards.length > 0">
        <table mat-table class="rep-inventory" [dataSource]="inventoryCards">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                <td mat-cell *matCellDef="let inv">
                    <svg class="lifecycle" [ngClass]="inv.LifeCycle">
                        <circle class="cls-3" cx="0.5em" cy="0.5em" r="0.5em">
                        </circle>
                    </svg>
                    {{inv.InventoryID}}
                </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let inv">{{inv.Description}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let inv">{{inv.QtyAvailable}} {{inv.BaseUnit}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tableColumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let inventoryCards; columns: tableColumnsToDisplay"></tr>
        </table>
    </mat-tab>
    <mat-tab label="Binders" *ngIf="inventoryBinders.length > 0">
        <table mat-table class="rep-inventory" [dataSource]="inventoryBinders">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                <td mat-cell *matCellDef="let inv">
                    <svg class="lifecycle" [ngClass]="inv.LifeCycle">
                        <circle class="cls-3" cx="0.5em" cy="0.5em" r="0.5em">
                        </circle>
                    </svg>
                    {{inv.InventoryID}}
                </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let inv">{{inv.Description}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let inv">{{inv.QtyAvailable}} {{inv.BaseUnit}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tableColumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let inventoryBinders; columns: tableColumnsToDisplay"></tr>
        </table>
    </mat-tab>
    <mat-tab label="Supplies" *ngIf="inventorySupplies.length > 0">
        <table mat-table class="rep-inventory" [dataSource]="inventorySupplies">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                <td mat-cell *matCellDef="let inv">
                    <svg class="lifecycle" [ngClass]="inv.LifeCycle">
                        <circle class="cls-3" cx="0.5em" cy="0.5em" r="0.5em">
                        </circle>
                    </svg>
                    {{inv.InventoryID}}
                </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let inv">{{inv.Description}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let inv">{{inv.QtyAvailable}} {{inv.BaseUnit}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tableColumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let inventorySupplies; columns: tableColumnsToDisplay"></tr>
        </table>
    </mat-tab>
    <mat-tab label="Other" *ngIf="inventoryOther.length > 0">
        <table mat-table class="rep-inventory" [dataSource]="inventoryOther">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                <td mat-cell *matCellDef="let inv">
                    <svg class="lifecycle" [ngClass]="inv.LifeCycle">
                        <circle class="cls-3" cx="0.5em" cy="0.5em" r="0.5em">
                        </circle>
                    </svg>
                    {{inv.InventoryID}}
                </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let inv">{{inv.Description}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let inv">{{inv.Quantity}} {{inv.BaseUnit}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tableColumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let inventoryOther; columns: tableColumnsToDisplay"></tr>
        </table>
    </mat-tab>
</mat-tab-group>

<!-- <table *ngIf="inventory" id="rep-inventory" style="width:100%;">
    <tbody *ngFor="let item of inventory">
        <tr *ngIf="item.RowHeader">
            <td colspan="4">{{item.RowHeader}}</td>
        </tr>
        <tr *ngIf="!item.RowHeader">
            <td class="col-pad"></td>
            <td>{{item.InventoryID}}</td>
            <td>{{item.Description}}</td>
            <td class="col-qty">{{item.Quantity}} {{item.BaseUnit}}</td>
        </tr>
    </tbody>
</table> -->